import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import UserMenu from './UserMenu';
import NavMenu from './NavMenu';
import Tools from './Tools';
import Sidebar from './Sidebar';
import axios from 'axios';
import './css/Home.css';
import { ReactComponent as IconMyTasks } from './icons/myTasks.svg';
import {CalendarIcon, Download} from './icons/svgIcons';

import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-modern-calendar-datepicker';

const getTodayDateObject = () => {
    const today = new Date();
    return { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() };
};

const Tasks = (props) => {
    const [tasks, setTasks] = useState([]);
    const [sessionData, setSessionData] = useState({});
    const [error, setError] = useState(false);
    const [paginationLimit, setPaginationLimit] = useState(0);
    const [paginationLength, setPaginationLength] = useState(10);

    const [taskPagination, setTaskPagination] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedDayRange, setSelectedDayRange] = useState({ from: getTodayDateObject(), to: getTodayDateObject() });

    const history = useHistory();

    useEffect(() => {
        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login');
        }
    }, []);



    useEffect(() => {
        if (selectedDayRange.to !== null) {
            getTasks();
        }
    }, [selectedDayRange]);

    const getNextPagination = () => {
        setPaginationLimit(paginationLimit + paginationLength);
        getTasks((paginationLimit + paginationLength), paginationLength);
    }

    const logout = () => {
        alert('Se sesión de usuario ha finalizado, es necesario que vuelva a iniciar sesión.');
        sessionStorage.clear();
        history.push('/login');
    }

    const customLocaleSpanish = {
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',],

        weekDays: [{ name: 'Lunes', short: 'L', }, { name: 'Martes', short: 'M', }, { name: 'Miércoles', short: 'M', }, { name: 'Jueves', short: 'J', }, { name: 'Viernes', short: 'V', }, { name: 'Sábado', short: 'S', isWeekend: true, }, { name: 'Domingo', short: 'D', isWeekend: true, },],
        weekStartingIndex: 6,
        getToday(gregorainTodayObject) {
            return gregorainTodayObject;
        },

        toNativeDate(date) {
            return new Date(date.year, date.month - 1, date.day);
        },

        getMonthLength(date) {
            return new Date(date.year, date.month, 0).getDate();
        },

        transformDigit(digit) {
            return digit;
        },

        // texts in the date picker
        nextMonth: 'Próximo mes',
        previousMonth: 'Mes anterior',
        openMonthSelector: 'Selector de mes',
        openYearSelector: 'Selector de año',
        closeMonthSelector: 'Cerrar selector de mes',
        closeYearSelector: 'Cerrar selector de año',
        defaultPlaceholder: 'Seleccionar...',

        // for input range value
        from: 'Del',
        to: 'al',


        // used for input value when multi dates are selected
        digitSeparator: ',',

        // if your provide -2 for example, year will be 2 digited
        yearLetterSkip: 0,

        // is your language rtl or ltr?
        isRtl: false,
    }


    const getTasks = (pagination = null, download=null) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
    
        let serviceParams = {}
        if (pagination) { serviceParams.pagination = pagination }
       
    
        
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/executive_tasks`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: serviceParams
        };

        if (selectedDayRange.to !== null) {options.params.selectedDayRange = selectedDayRange;}
        if (download) { 
            options.params.download = 'yes'; 
        } else {
            setLoading(true);
        }

        axios(options).then(response => {
            if (!download) { 
                setTasks(response.data[0].data);
                if (pagination) {
                    setTasks([...tasks, ...response.data[0].data]);
                }
                else {
                    setTasks(response.data[0].data);
                }
        
                setTaskPagination(response.data[0].metadata[0]);
                setLoading(false);
            } else {
                let csv = 'data:text/csv;charset=utf-8,' + response.data;
                let csvData = encodeURI(csv);
                window.open(csvData);
            }
        })
        .catch(function (error) {
            console.log('Se produjo un errrooooor:', error);
            setLoading(false);
            setError(error);
        });
    
    }

    const fixedHeaderPosition={top:"152px"};

    return (
        <div className="mainWrapper">
            <Sidebar key={props.inboundConnectedQueues} softphoneConnectionStatus={props.softphoneConnectionStatus}/>
            <div className="main">
            <div className="headerWrapper">
                <div className="titleWrapper">
                    <h1 className={loading?'loading':''}><IconMyTasks/>Mis Gestiones</h1>
                    <span className="upper">Listado de mis gestiones diarias.</span>
                </div>
                <div className="flexWrapper"> 
                    <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues}/>
                </div>
            </div>

            <div className="taskFilter rel">
                <DatePicker
                    value={selectedDayRange}
                    onChange={setSelectedDayRange} 
                    inputPlaceholder="Filtro fechas" 
                    locale={customLocaleSpanish}
                    shouldHighlightWeekends
                    inputClassName="datePickerInput pr40"
                />
                <CalendarIcon style={{"position": "absolute", "top": "11px", "transform": "translateX(-30px)", zIndex: 3, pointerEvents: "none"}}/>
            </div>

            <div className="tableWrapper">
                <table className="fullWidth">
                    <thead>
                        <tr>
                            <th style={fixedHeaderPosition}>#</th>
                            <th style={fixedHeaderPosition}>Fecha</th>
                            <th style={fixedHeaderPosition}>Cliente</th>
                            <th style={fixedHeaderPosition}>Rut</th>
                            <th style={fixedHeaderPosition}>Teléfono</th>
                            <th style={fixedHeaderPosition}>Empresa</th>
                            <th style={fixedHeaderPosition}>Campaña</th>
                            <th style={fixedHeaderPosition}>TContacto</th>
                            <th style={fixedHeaderPosition}>TGestión</th>
                            <th style={fixedHeaderPosition}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map((task, index) => {
                            return (
                                <tr key={index}>
                                    <td align="right">{index+1}</td>
                                    <td className='wsNormal'>{Tools.fdtCL(task.executiveTasks.date)}</td>
                                    <td className='wsNormal'>{task.clienteNombre} { task.clienteApPat }</td>
                                    <td>{task.clientId}</td>
                                    <td>{task.executiveTasks.phone}</td>
                                    <td className='wsNormal'>
                                        <span className='companyColor' style={{borderColor:task.executiveTasks.CNY_DETAILS.color}}>{task.executiveTasks.CNY_DETAILS.code}</span>
                                    </td>
                                    <td className='wsNormal'>{task.executiveTasks.CMP_DETAILS.name}</td>
                                    <td className='wsNormal'>{task.executiveTasks.CT_DETAILS.desc}</td>
                                    <td className='wsNormal'>{task.executiveTasks.TK_DETAILS.desc}</td>
                                    <td><a className="link" onClick={() => { history.push("/" + task.executiveTasks.CMP_DETAILS._id + "/" + task.clientId + "/" + task.executiveTasks.phone); }}>Revisar</a></td>
                                </tr>  
                            );      
                        })}   
                    </tbody>            
                </table>
            </div>
            <br/>

            {taskPagination ? (
                    <div className="paginationWrapper">
                        <p className="pagination">
                            Mostrando [{tasks.length} de {taskPagination.total} registros]
                            {(tasks.length < taskPagination.total) ? (
                                <span> &nbsp; <a className={loading.tasks ? 'link loading' : 'link'} onClick={() => getTasks({ page: taskPagination.page + 1, skip: tasks.length, limit: 10 })}>Ver más</a></span>
                            ) : null}
                        </p>

                        {selectedDayRange.to !== null?(
                            <a className='link icon' onClick={() => { getTasks(null, true) }}><Download/>Generar</a>
                        ) : null}

                    </div>
                ) : null
            }
        </div>
        </div>
    );
}

export default Tasks;